{
	"title": "Transaction details",
	"backToPageLabel": "Back to Product allocation",
	"showTransactionDetails": "Show transaction details \u2013 Hashscan.io",
	"flagIncorrectAllocation": "Flag incorrect carbon allocation",
	"resolveIncorrectAllocation": "Carbon allocation resolved"
}
